<div class="modal-header" id="participant-copies-modal-title">
    <h3 class="modal-title" id="modal-title" translate="HISTORICAL_VALUES_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>

<div class="modal-body modal-body-historical-values-list">
    <table class="table text-center">
        <thead>
            <tr>
                <th translate="HISTORICAL_VALUES_VALUE_RECORDED" scope="col"></th>
                <th translate="HISTORICAL_VALUES_DATE" scope="col"></th>
            </tr>
        </thead>
        <tbody>
            @for (historicalValue of historicalValues$ | async; track historicalValue.date) {
                <tr>
                    <td>{{ historicalValue.value }}</td>
                    <td>{{ historicalValue.date }}</td>
                </tr>
            }
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" [disabled]="disableLoadMoreButton$ | async" (click)="loadAllValues()" class="btn btn-primary">
        {{ 'HISTORICAL_VALUES_LOAD_ALL_VALUES' | translate }}
    </button>
</div>
